// extracted by mini-css-extract-plugin
export default {"about":"About_about__b6ZN+","row":"About_row__CHwZ2"};